<template>
  <fc-designer ref="designer"
               :config="useConfig"
               v-bind="$attrs"
               v-on="$listeners" />
</template>

<script>
export default {
  name: 'FormDesigner',
  props: {
    config: Object
  },
  data () {
    return {
      defaultConfig: {
        showLanguage: false,
        showAi: false,
        fieldReadonly: false,
        formOptions: {
          form: {
            size: 'small'
          }
        }
      }
    }
  },
  computed: {
    useConfig () {
      return this.$extend(this.defaultConfig, this.config)
    }
  },
  mounted () {
    const designer = this.$refs.designer
    if (designer) {
      Object.keys(designer).forEach(key => {
        if (typeof designer[key] === 'function' && !this[key]) {
          this[key] = designer[key].bind(designer)
        }
      })
    }
  }
}
</script>
